(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusControllers')
        .controller('ActionPlanUpdateStatusGovernanceProcessEditController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', '$timeout', 'govNotificationDelay', 'notificationService', 'grcGovernanceProcessService', 'recomService', 'permissionService'];

    function Controller($rootScope, $scope, $state, $timeout, govNotificationDelay, notificationService, grcGovernanceProcessService, recomService, permissionService) {

        $scope.ctxtCtrl = {};

        grcGovernanceProcessService
            .getFiscalYears()
            .then(function (fiscalYears) {
                $scope.fiscalYears = fiscalYears;
            })

        $scope.govProcess = $scope.govProcess || {};
        $scope.govProcess.RecomBusinessUnitID = $scope.businessUnit.RecomBusinessUnitID;

        if (!$scope.govProcess.GovernanceProcessID) {
            $scope.govProcess.IsActive = true;
        }

        // Is Create or Update Disabled?
        $scope.isCreateOrUpdateDisabled = function (form) {
            if (_.isUndefined(form)) return true;

            return form.$invalid;
        };

        // Create or Update
        $scope.createOrUpdate = function () {
            if ($scope.form.$invalid) {
                showFormError();
                return;
            }

            $scope.ctxtCtrl.isLoading = true;
            $scope.ctxtCtrl.isFormInvalidMsgShow = false;

            if (!$scope.govProcess.GovernanceProcessID) {
                return createGovernanceProcess();
            }

            return updateGovernanceProcess();
        };

        function createGovernanceProcess() {
            return recomService
                .createGovernanceProcess($scope.govProcess)
                .then(function (createdGovProcess) {
                    notificationService.notify('The Governance Process was created');
                    $scope.form.$setPristine();

                    // if manual assesment redirect to assessment selection screen
                    if (createdGovProcess.RecomBusinessUnit.HasActionPlan_ManuallyCreateAssessment)
                        $state.go('actionPlanUpdateStatusSelectAssessment', { BusinessUnitCode: createdGovProcess.RecomBusinessUnit.Code, GovernanceProcessID: createdGovProcess.GovernanceProcessID });
                    else
                        $state.go('actionPlanUpdateStatusOwnerList', { BusinessUnitCode: createdGovProcess.RecomBusinessUnit.Code, GovernanceProcessID: createdGovProcess.GovernanceProcessID });
                })
                .finally(function () {
                    $scope.ctxtCtrl.isLoading = false;
                    $scope.hideModal();
                });
        }

        function updateGovernanceProcess() {
            return recomService
                .updateGovernanceProcess($scope.govProcess)
                .then(function (updatedGovernanceProcess) {
                    notificationService.notify('The Governance Process was updated');
                    $scope.form.$setPristine();

                    $scope.govProcess = updatedGovernanceProcess;
                    if (!$scope.govProcess.IsActive) {
                        $state.go('recom.listGovernanceProcess', { replace: true });
                    }
                })
                .finally(function () {
                    $scope.ctxtCtrl.isLoading = false;
                    $scope.hideModal();
                });
        }

        function showFormError() {
            $scope.ctxtCtrl.showSubmitError = true;
            $scope.ctxtCtrl.isFormInvalidMsgShow = true;
            $timeout(function () {
                $scope.ctxtCtrl.isFormInvalidMsgShow = false;
            }, govNotificationDelay);
        }
    }
})();